export default {
	PHONE_NUMBER_LABEL: 'Phone Number'
};
